import { Component } from '@angular/core';

import { Permission, SecurityScope } from '../../../auth/auth.model';
import { AuthService } from '../../../auth/auth.service';
import { ChatMenuDialogService } from '../dialog';

import { TranslationKeyMap } from './chat-menu-nav-button.i18n';

@Component({
    selector: 'cmps-teamscall-chat-menu-nav-button',
    templateUrl: './chat-menu-nav-button.component.html',
    host: {
        class: 'cmps-teamscall-chat-menu-nav-button',
        '[class.cmps-teamscall-chat-menu-nav-button--disabled]': '!_hasChat',
    },
})
export class ChatMenuNavButtonComponent {
    /** @private */ _i18n = TranslationKeyMap;

    /** @private */ _hasChat: boolean;

    constructor(
        /** @private */ readonly _dialogService: ChatMenuDialogService,
        private readonly _authService: AuthService,
    ) {
        this._hasChat = this._authService.user.hasPermission(
            Permission.TEAMS_CALL_CREATE_CHAT,
            SecurityScope.COACHING_COMMITMENT,
        );
    }
}
